import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import Box from '@talkdesk/cobalt-react-box'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

/** @param {{ title: any, message?: any }} props */
const ContentHeader = ({ title, message }) => {
  const theme = useTheme()

  return (
    <Box as='header' padding='1'>
      <Heading level='3' textAlign='center'>
        {title}
      </Heading>
      {message ? (
        <Box paddingY='2'>
          <Text color={theme.gray600} textAlign='center'>
            {message}
          </Text>
        </Box>
      ) : null}
    </Box>
  )
}

export default ContentHeader
